// When a piece's armour earns a mark on the board (§31 K1).
//
// Every knight and rook is born plated now (`PIECE_PLATING`), so "plated" is
// no longer news: a bar or a carrier badge on every whole rook is a board
// where everything is marked. The plate earns a board mark when it is **worn**
// (below its cap — it will regenerate) or **extra** (a cap above the rank's
// base — granted, by a row or a card). The inspector's pip and stats row still
// say it on every plated piece; those are read on a selected piece, not
// scanned across the board.

import { pieceType } from "src/engine/rules/board";
import { pieceAt, platingAt, platingCapAt, type Position } from "src/engine/rules/position";
import { PIECE_PLATING } from "src/engine/rules/rules";

export function plateWorthMarking(position: Position, square: number): boolean {
  const piece = pieceAt(position, square);
  if (!piece) return false;
  const cap = platingCapAt(position, square);
  if (cap <= 0) return false;
  return platingAt(position, square) < cap || cap > PIECE_PLATING[pieceType(piece)];
}
